import { ErrorLevel } from '../../error/error';
import errorIcon from '../../../../images/preview/tv_error.svg';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import React, { useContext } from 'react';
import { DemoContext } from '../../Demo';

export const PlayerErrorBoundary = ({ error, children }) => {
  const errorLevelRenderer = {
    [ErrorLevel.ERROR]: () => <PlayerError error={error}/>,
    [ErrorLevel.WARNING]: () => <PlayerWarning error={error}
                                               children={children}/>,
  };
  return !!errorLevelRenderer[error?.level] ?
    errorLevelRenderer[error.level]() :
    children;
};

const PlayerWarning = ({ error, children }) => {
  const {isExternal} = useContext(DemoContext);
  return <>
    {children}
    <MessageTitle>{error.message}</MessageTitle>
    <MessageSubtitle>{error.subMessage}</MessageSubtitle>
    {!isExternal && <SupportMessage/>}
  </>;
}

const PlayerError = ({ error }) => {
  const {isExternal} = useContext(DemoContext);
  return <>
    <ErrorImg src={errorIcon}/>
    <MessageTitle>{error.message}</MessageTitle>
    <MessageSubtitle>{error.subMessage}</MessageSubtitle>
    {!isExternal && <SupportMessage/>}
  </>;
}

const supportMessage = css`
    position: absolute;
    top: 83%;
    color: white;
    font-size: 1vw;
    z-index: 10;
`;

const SupportMessage = () => <div css={supportMessage}>Contact
  composersupport@innovid.com for assistance</div>;

const ErrorImg = styled.img`
  text-align: center;
  position: absolute;
  background-color: transparent;
  width: 10%;
  height: 10%;
  top: 40%;
  z-index: 10;
`;

const MessageTitle = styled.div`
    text-align: center;
    width: 60%;
    position: absolute;
    top: 55%;
    color: white;
    font-size: 1.5vw;
    z-index: 10;
`;

const MessageSubtitle = styled.div`
    font-family: proximanova-semibold;
    text-align: center;
    position: absolute;
    top: 78%;
    color: white;
    font-size: 1.1vw;
    z-index: 10;
`;
